export function getFinancialTabs(t) {
  return [
    {
      label: t('financial.tabs.recharge'),
      key: 'recharge',
    },
    {
      label: t('financial.tabs.expenditure'),
      key: 'expenditure',
    },
  ]
}
